import { render, staticRenderFns } from "./listItemClient.vue?vue&type=template&id=2aad7179&scoped=true&"
import script from "./listItemClient.vue?vue&type=script&lang=js&"
export * from "./listItemClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aad7179",
  null
  
)

export default component.exports